var map = {
	"./AlertPerson.svg": "5568",
	"./BurgerPerson.svg": "327b",
	"./CheckMark.svg": "4ddc",
	"./CheckMarkBig.svg": "3e05",
	"./CheckPerson.svg": "a98d",
	"./Checklist.svg": "862d",
	"./Computer.svg": "7668",
	"./DFMText.svg": "fff5",
	"./Files.svg": "5053",
	"./Graph.svg": "6fb2",
	"./Handshake.svg": "fac4",
	"./Hat.svg": "8e29",
	"./Internet.svg": "9463",
	"./PenPencil.svg": "cf93",
	"./PenPencilTwo.svg": "87f6",
	"./School.svg": "4145",
	"./Whiteboard.svg": "67b8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8398";